import React, { memo } from "react";
import * as PropTypes from "prop-types";
import { formatValue } from "../../../utilities";
import GniGroupBySectorChart from "../charts/GniGroupBySectorChart";

const CurrentSpendingChart = props => (
  <GniGroupBySectorChart
    ref={props.innerRef}
    data={props.data.map(datum => ({
      ...datum,
      name: datum.name.replace("sidized", "").replace("Government", "Gov't")
    }))}
    indicatorId={2}
    sectorIds={new Set([1, 2, 4, 5])}
    seriesNames={[
      "Donor",
      "Government",
      "Private Subsidized",
      "Private Non-Subsidized"
    ].reverse()}
    reversedStacks={true}
    tooltipFormatter={function() {
      return `${this.series.name} Share of ${
        this.key
      } Spending: <strong>${formatValue(this.percentage / 100, true)}</strong>`;
    }}
  />
);

CurrentSpendingChart.propTypes = {
  data: PropTypes.array.isRequired
};

export default memo(
  React.forwardRef((props, ref) => (
    <CurrentSpendingChart innerRef={ref} {...props} />
  ))
);
